const route = {
  title: 'Expenses',
  path: '/ap/expenses',
  scopes: ['ap.manage', 'ap/expenses.manage'],
  menuGroup: 'Payables',
}

export const ApExpensesPage = createPage(route, () => {
  return pug`
    Main
      .min-h-full.p-2.col.center
        Icon.h-20.mb-4.text-red-800.opacity-50(icon='times-circle')
  `
})
